import type { ScenePlan } from './htmlDesignSlice';

import type { RootState } from 'js/src/libs/RootState';

export const getCodeoEditModeSceneId = (state: RootState): string | null =>
    state.htmlDesign?.activeConversationTarget?.sceneId ?? null;

export const getHtmlDesignPlan = (state: RootState, sceneId: string): ScenePlan | null =>
    state.htmlDesign?.planBySceneId?.[sceneId] ?? null;
